/** Merge the session's one-off `initialStructuredInput` with a per-message one.
 * The per-message payload wins on key collision, and `carriesInitial` tells the
 * caller whether this invoke is the one that delivers the session context. */
export const resolveStructuredInput = ({
  initialStructuredInput,
  perMessage,
  alreadySent,
}: {
  initialStructuredInput?: Record<string, unknown> | null;
  perMessage?: Record<string, unknown> | null;
  alreadySent: boolean;
}): {
  payload: Record<string, unknown> | undefined;
  carriesInitial: boolean;
} => {
  const pending =
    initialStructuredInput && !alreadySent ? initialStructuredInput : null;
  if (!pending)
    return { payload: perMessage ?? undefined, carriesInitial: false };
  return { payload: { ...pending, ...perMessage }, carriesInitial: true };
};
